import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { Clipboard } from "@angular/cdk/clipboard";
import { SafeUrl } from "@angular/platform-browser";
import { NbDialogRef, NbDialogService, NbGlobalPhysicalPosition, NbPopoverDirective, NbToastrService } from "@nebular/theme";
import { CallFlowClient, GenerateLinkTestingCommand } from "../../System-api";
import { FormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { RxFormBuilder, RxwebValidators } from "@rxweb/reactive-form-validators";
import { encodeAllCharacters, noWhitespaceValidator } from "../../@core/utils/helpers";

@Component({
  selector: "generate-qr",
  templateUrl: "./generate-qr.component.html",
  styleUrls: ["./generate-qr.component.scss"],
})
export class GenerateQRComponent implements OnInit {
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  botForm: UntypedFormGroup;
  logoDefault = "../../../assets/images/logo-bot-default.png";
  qrCodeDownloadLink: SafeUrl = "";
  testChatUrl = "";
  testCallUrl = "";
  botName = "";
  data: any;
  activeTab: number = 0;

  constructor(
    private callflowClient: CallFlowClient,
    protected ref: NbDialogRef<GenerateQRComponent>,
    private clipboard: Clipboard,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    private cd: ChangeDetectorRef,
    private formBuilder: RxFormBuilder
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.botName = this.data.callSettings[0]?.botName?.trim() || this.data.name;
    this.testChatUrl = this.generateChatUrl();
    this.callflowClient
      .generateLinkTesting(
        new GenerateLinkTestingCommand({
          id: this.data.id,
          callFlowJson: this.data.jsonFormat,
          callSettings: JSON.stringify(this.data.callSettings[0]),
          attribute: this.data.attribute,
          name: this.data.callSettings[0].botName?.trim() || this.data.callSettings[0].callFlowName?.trim() || "Primas Bot",
        })
      )
      .subscribe({
        next: (rs) => {
          this.testCallUrl = rs;
          this.testCallUrl = encodeURI(this.testCallUrl);
        },
        error: (error) => {
          this.toastrService.show("Something went wrong. Please try again later.", `Notification`, {
            position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
            status: "danger",
          });
        },
      });
  }
  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }

  createForm() {
    this.botForm = this.formBuilder.group({
      name: new FormControl("", [RxwebValidators.required(), noWhitespaceValidator, Validators.maxLength(50)]),
    });
  }

  saveAsImage(id) {
    let parentElement = null;
    parentElement = document.querySelector(id + " > div > canvas");
    if (parentElement) {
      parentElement = parentElement.toDataURL("image/png");
      // converts base 64 encoded image to blobData
      let blobData = this.convertBase64ToBlob(parentElement);
      // saves as image
      const blob = new Blob([blobData], { type: "image/png" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      // name of the file
      link.download = "primas-test-QR";
      link.click();
    }
  }

  private convertBase64ToBlob(Base64Image: string) {
    // split into two parts
    const parts = Base64Image.split(";base64,");
    // hold the content type
    const imageType = parts[0].split(":")[1];
    // decode base64 string
    const decodedData = window.atob(parts[1]);
    // create unit8array of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);
    // insert all character code into uint8array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // return blob image after conversion
    return new Blob([uInt8Array], { type: imageType });
  }

  copy(content: string) {
    this.clipboard.copy(content);
    this.toastrService.show("Copied to Clipboard", "Notification", {
      position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
      status: "success",
    });
  }

  updateBotName(event) {
    this.botName = event.target.value;
    this.testChatUrl = this.generateChatUrl();
    this.testCallUrl = this.testCallUrl.replace(/(botName=)[^&]*/, "botName=" + encodeAllCharacters(`${this.botName}`));
  }

  generateChatUrl() {
    let logo = this.data.callSettings[0]?.botLogo?.trim()
      ? "&logoUrl=" + encodeAllCharacters(this.data.callSettings[0].botLogo.trim())
      : "";
    let greeting = this.data.callSettings[0]?.botGreetingMessages?.trim()
      ? "&greetingMessage=" + encodeAllCharacters(this.data.callSettings[0].botGreetingMessages.trim())
      : "";
    this.testChatUrl = this.data.chatUrl + "&name=" + encodeAllCharacters(this.botName) + logo + greeting;
    return this.testChatUrl;
  }

  dismiss() {
    this.ref.close();
  }
}
